import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { doc, getDoc, serverTimestamp, setDoc } from "firebase/firestore";
import { FcGoogle } from "react-icons/fc";
import { Button } from "@mantine/core";
import { toast } from "react-toastify";
import { db } from "../firebase";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

interface GoogleAuthProps {
  disabled: boolean;
}

const GoogleAuth: React.FC<GoogleAuthProps> = ({ disabled }) => {
  const intl = useIntl();
  const navigate = useNavigate();

  async function onGoogleClick() {
    try {
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      //console.log(user);
      // check for the user

      const docRef = doc(db, "users", user.uid);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) {
        await setDoc(docRef, {
          name: user.displayName,
          email: user.email,
          timestamp: serverTimestamp(),
        });
      }

      navigate("/");
    } catch (error) {
      toast.error("Could not authorize with Google");
    }
  }

  return (
    <Button
      fullWidth
      disabled={disabled}
      onClick={onGoogleClick}
      className="google-button"
    >
      <FcGoogle className="google-icon" />
      {intl.formatMessage({ id: "signin.continueWithGoogle" })}
    </Button>
  );
};

export default GoogleAuth;
